const CalendarTypes = {
    OPEN_CALENDAR_DETAIL: '@@calendar/OPEN_CALENDAR_DETAIL'
};

export default CalendarTypes;
